// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1781":"83887d59","3165":"70f0e70d","4414":"69f89c8c","5052":"34ad96d4","5943":"bebe8439","8642":"6ef84be3"}[chunkId] + ".chunk.css";
};